'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Quiz = require('./Quiz.scss');

var _Quiz2 = _interopRequireDefault(_Quiz);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trueOrFalseAnswers = [{
  value: true,
  label: 'Vrai'
}, {
  value: false,
  label: 'Faux'
}];

var QuizTrueOrFalse = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QuizTrueOrFalse, _Component);

  function QuizTrueOrFalse(props) {
    (0, _classCallCheck3.default)(this, QuizTrueOrFalse);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuizTrueOrFalse.__proto__ || (0, _getPrototypeOf2.default)(QuizTrueOrFalse)).call(this, props));

    _this.handleChange = function (value) {
      var onChange = _this.props.onChange;

      onChange(value);
    };

    return _this;
  }

  (0, _createClass3.default)(QuizTrueOrFalse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var answer = this.props.answer;


      return _react2.default.createElement(
        'ul',
        { style: { padding: 0, listStyle: 'none' } },
        trueOrFalseAnswers.map(function (_ref, index) {
          var label = _ref.label,
              value = _ref.value;
          return _react2.default.createElement(
            'li',
            {
              key: index,
              style: {
                border: '1px solid #000',
                padding: '10px 20px',
                listStyle: 'none',
                marginBottom: '10px',
                alignItems: 'center',
                display: 'flex'
              }
            },
            _react2.default.createElement('input', {
              type: 'checkbox',
              checked: answer === value,
              style: { marginRight: '8px' },
              onClick: function onClick() {
                return _this2.handleChange(value);
              }
            }),
            _react2.default.createElement(
              'div',
              {
                className: _Quiz2.default.answerContent
              },
              label
            )
          );
        })
      );
    }
  }]);
  return QuizTrueOrFalse;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  answer: _react.PropTypes.object.isRequired,
  innerHTML: _react.PropTypes.func.isRequired
}, _temp);
exports.default = QuizTrueOrFalse;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Quiz/QuizTrueOrFalse.js
// module id = 1182
// module chunks = 0